import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Envasado`, method: 'GET', body: null, token: token})
}
